import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useAppContext } from 'utils/hooks';
import { AuthContext } from 'context/AuthContext';
import ROUTES from 'config/nav/admin/routes';
import { ReactComponent as GearIcon } from 'assets/img/icons/gear.svg';

export default function AccountSettingsOption() {
  const { push } = useHistory();

  const { isSSREnv } = useAppContext();
  const { roles } = useContext(AuthContext);

  const isAdmin = _get(roles, 'admin', false);

  if (isSSREnv || !isAdmin) return null;

  return (
    <UiKit.Dropdown.Option onClick={() => push(ROUTES.ACCOUNT_SETTINGS.ROOT)}>
      <GearIcon className={styles.icon} />
      Account Settings
    </UiKit.Dropdown.Option>
  );
}
